
export class CookieTractorCustomEvents {

    private readonly BLIWA_COOKIENAME: string = "_bliwa_cc_consent";
    private readonly COOKIETRACTOR_COOKIENAME: string = "_cc_cookieConsent";
    private initialDocumentConsents: number = 0;

    private hasConsentOnDocumentLoad: boolean = false;
    constructor() {
        this.Init();
    }

    private Init() {
        this.hasConsentOnDocumentLoad = this.HasConsent();
        var clientId = (window as any).cookieTractor.consent.key as string;
        this.initialDocumentConsents = ((window as any).cookieTractor.consent.current as string[]).length;

        if (clientId === null || clientId === undefined || clientId.trim().length === 0) {
            //Om vi saknar klientID (Saknar medgivande för klienten.), Raderar vår custom-kaka som speglar klientens consent genom Cookie Tractor
            this.SetCookie(this.BLIWA_COOKIENAME, '', 0);

            //Raderar även Cookie Tractors consent cookie om så är fallet.
            (window as any).cookieTractor.cookie.remove();
        }

        this.AddCustomEventListeners();
    }

    private AddCustomEventListeners(): void {
        window.addEventListener('CookieConsentGiven', (event) => {
            this.CreateOrUpdateCustomConsentCookie();
        }, false);

        window.addEventListener('CookieConsentRevoked', (event) => {
            this.CreateOrUpdateCustomConsentCookie();
        }, false);
    }

    private CreateOrUpdateCustomConsentCookie(): void {

        var reloadDocument = false;

        var clientId = (window as any).cookieTractor.consent.key as string;
        var clientConsents = (window as any).cookieTractor.consent.current as string[];

        var clientContentObject = {
            ClientId: clientId,
            ClientConsents: clientConsents
        };

        var hasBliwaCookie = this.HasCookieByName(this.BLIWA_COOKIENAME);
        var hasCookieTractorCookie = this.HasCookieByName(this.COOKIETRACTOR_COOKIENAME);
        var hasUpdatedConsent = this.initialDocumentConsents !== clientConsents.length;

        var jsonClientContsent = encodeURIComponent(JSON.stringify(clientContentObject));

        this.SetCookie(this.BLIWA_COOKIENAME, jsonClientContsent, 365);

        //Tar bort custom-kakan om vi saknar samtycke men har custom-kakan kvar
        if (this.hasConsentOnDocumentLoad === false && hasBliwaCookie) {
            this.SetCookie(this.BLIWA_COOKIENAME, '', 0);
        }

        //Laddar om dokumentet om vi har samtycke men saknar custom-kakan, eller att vi har samtycke men saknar bliwa-kakan
        if ((this.hasConsentOnDocumentLoad === true && hasBliwaCookie === false) ||
            (hasCookieTractorCookie && hasBliwaCookie === false) ||
            hasUpdatedConsent) {
            reloadDocument = true;
        }

        if (reloadDocument) {
            window.location.reload();
        }
    }

    private SetCookie(cookieName: string, consent: string, days: number) : void {
        var now = new Date();
        var time = now.getTime();
        time += 3600 * 1000 * (24 * days);
        now.setTime(time);
        document.cookie =
            cookieName + '=' + consent +
            '; expires=' + now.toUTCString() +
            '; domain=.bliwa.se' +
            '; secure=true' +
            '; samesite=none' +
            '; path=/';
    }

    private HasConsent(): boolean {
        var clientConsents = (window as any).cookieTractor.consent.current as string[];

        if (clientConsents.length > 0) {
            return true;
        }

        return false;
    }

    private HasCookieByName(name: string): boolean {

        var exist: boolean = false;

        if (document.cookie.length > 0) {
            document.cookie.split(';').forEach((cookie: string) => {
                let cookieData = cookie.split('=');
                let cookieName = cookieData[0].trim();

                if (cookieName === name) {
                    exist = true;
                }
            });
        }

        return exist;
    }
}